import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { useBaseStorefrontAnalytics } from '@hooks/useBaseStorefrontAnalytics';
import { useCallback } from 'react';

export const useTrackReviewInteraction = () => {
	const { track } = useAnalyticsContext();
	const baseStorefrontAnalytics = useBaseStorefrontAnalytics();

	return useCallback(
		(properties: Record<string, unknown>) => {
			track({
				event: 'Review Interaction',
				properties: {
					...baseStorefrontAnalytics,
					...properties,
				},
			});
		},
		[track, baseStorefrontAnalytics],
	);
};
